<template>
  <section class="settings-row">
    <div class="settings-row__description">
      <h6 v-if="title" class="settings-row__title">{{ title }}</h6>
      <p v-if="description">{{ description }}</p>
      <slot name="description" />
    </div>
    <div class="settings-row__control"><slot /></div>
  </section>
</template>
<script>
export default {
  name: "SettingsRow",
  props: { title: String, description: String },
};
</script>
<style scoped>
.settings-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.85fr);
  column-gap: 32px;
  align-items: start;
}
.settings-row + .settings-row {
  border-top: 1px solid var(--settings-border, #e2e8f0);
  margin-top: 20px;
  padding-top: 20px;
}
.settings-row__title {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: #334155;
}
.settings-row__description p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #475569;
}
.settings-row__control {
  min-width: 0;
}
@media (max-width: 999px) {
  .settings-row {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
}
</style>
